import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage'; // Your existing component
import ProjectDetailPage from './pages/ProjectDetailPage'; // The new component
import Navbar from './components/Navbar';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* Route for individual project pages */}
        <Route path="/projects/:slug" element={<ProjectDetailPage />} />
        {/* Add other routes as needed */}
      </Routes>
      
    </Router>
  );
}

export default App;

